export enum GapFillingMethod {
    None = 'None',
    Filling = 'Filling'
}
